import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import FileUpload from "./FileUpload";
import PageWrapper from "../layout/PageWrapper";
import AddTransactionForm from "../forms/TransactionForm";
import { useNavigate } from "react-router-dom";

const CreateTransaction: React.FC = () => {
  const [transactionType, setTransactionType] = useState<
    "income" | "expense" | null
  >(null);

  const navigate = useNavigate();

  const handleTabChange = () => {
    setTransactionType(null);
  };

  const closeTransaction = () => {
    setTransactionType(null);
  };

  return (
    <PageWrapper>
      <div
        className="flex flex-col max-w-md mx-auto w-[90%]"
        style={{ height: "100%" }}
      >
        <Tabs
          defaultValue="expense_tab"
          className="w-full h-full mx-auto flex-grow"
          onValueChange={handleTabChange}
        >
          <TabsList className="w-full">
            <TabsTrigger value="expense_tab" className="w-1/2 h-[90%] ml-[1%]">
              Add Expense
            </TabsTrigger>
            <TabsTrigger value="income_tab" className="w-1/2 h-[90%] mr-[1%]">
              Add Income
            </TabsTrigger>
          </TabsList>
          <TabsContent value="expense_tab" className="flex flex-col flex-grow">
            {!transactionType ? (
              <>
                <FileUpload />
                <div className="flex items-center my-4">
                  <div className="border-t border-gray-400 flex-grow"></div>
                  <span className="mx-4 text-gray-400">or</span>
                  <div className="border-t border-gray-400 flex-grow"></div>
                </div>
                <Button
                  variant={"secondary"}
                  onClick={() => setTransactionType("expense")}
                  className="w-full mt-2"
                >
                  Add Expense manually
                </Button>
              </>
            ) : (
              <AddTransactionForm
                mode={"new"}
                type={transactionType}
                isInDrawer={true}
                onCancel={closeTransaction}
                onSave={() => navigate("/")}
              />
            )}
          </TabsContent>
          <TabsContent value="income_tab" className="flex flex-col flex-grow">
            <AddTransactionForm
              mode={"new"}
              type={"income"}
              isInDrawer={true}
              onCancel={closeTransaction}
              onSave={() => navigate("/")}
            />
          </TabsContent>
        </Tabs>
        <div className="mt-auto w-full">
          <Button
            variant="outline"
            className="w-full mx-auto justify-center flex mt-2"
            // onClick={() => navigate('/')}
            onClick={() => window.history.back()}
          >
            Cancel
          </Button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default CreateTransaction;
